import { render, staticRenderFns } from "./LeftBar.vue?vue&type=template&id=27e6331a&scoped=true&"
import script from "./LeftBar.vue?vue&type=script&lang=js&"
export * from "./LeftBar.vue?vue&type=script&lang=js&"
import style0 from "./LeftBar.vue?vue&type=style&index=0&id=27e6331a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e6331a",
  null
  
)

export default component.exports